var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockIconsFinal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#234492",
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #234492;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55,29.97c.04,13.8-11.15,25.01-24.97,25.03-13.73,.02-24.98-11.17-25.02-24.89-.04-13.76,11.17-25.05,24.94-25.11,13.77-.05,25.01,11.15,25.05,24.97Zm-34.52,14.97c5.67,4.2,16.09,4.34,22.73-2.95,6.3-6.91,5.45-16.77,1.7-21.49-8.14,8.14-16.29,16.3-24.43,24.44ZM39.6,15.04c-6.71-4.73-16.89-3.44-22.72,2.92-6.22,6.79-5.63,16.5-1.8,21.6,8.17-8.17,16.35-16.35,24.52-24.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIconsFinal);
export default __webpack_public_path__ + "static/media/Block_icons_final.c91f1e1639a149a0f6f61c15d80fff06.svg";
export { ForwardRef as ReactComponent };